import { Flatfile } from '@flatfile/api-internal'
import { User, UserCreateAndInviteRequest } from '@flatfile/api-internal/api'
import { AppHTTPService } from '../http-service'

export interface UserWithRoles extends Flatfile.User {
  roles: UserRole[]
  hasPendingInvite?: boolean
}

export interface UserRole {
  id: string
  name: string
  resourceId: string
  resourceName: string
  actorRoleId: string
}
export interface UpdateUserWithRoles {
  id: User['id']
  name?: string
  dashboardVersion?: number
  roles?: {
    addedRoles?: {
      id: Flatfile.RoleId
      resourceId: string
    }[]
    deletedRoles?: {
      actorRoleId: Flatfile.ActorRoleId
    }[]
  }
}

export interface UsersWithRolesResponse {
  data: UserWithRoles[]
  pagination?: Flatfile.Pagination
}

export const getUsersWithRolesList = async ({
  search = '',
  pageNumber,
  pageSize,
}: {
  search?: string
  pageNumber?: number
  pageSize?: number
}): Promise<UsersWithRolesResponse> => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : ''
  const users = await AppHTTPService.axios.get(
    `${window.flatfile.configService.get('VITE_BASE_API_URL')}/v1/internal/users-with-roles?pageNumber=${pageNumber}&pageSize=${pageSize}${searchParam}`
  )

  return users.data
}

export const updateUserAndRoles = async (updatedUser: UpdateUserWithRoles) => {
  const response = await AppHTTPService.axios.patch(
    `${window.flatfile.configService.get('VITE_BASE_API_URL')}/v1/internal/user-with-roles/${updatedUser.id}`,
    updatedUser
  )

  return response.data
}

export const inviteUser = async (newUser: UserCreateAndInviteRequest) => {
  const response = await AppHTTPService.axios.post(
    `${window.flatfile.configService.get('VITE_BASE_API_URL')}/v1/internal/user-with-roles/invite`,
    newUser
  )

  return response.data
}

export const resendUserInvite = async (userId: string) => {
  const response = await AppHTTPService.axios.post(
    `${window.flatfile.configService.get('VITE_BASE_API_URL')}/v1/users/${userId}/resend-invite`
  )

  return response
}

export const deleteUser = async (userId: string) => {
  const response = await AppHTTPService.axios.delete(
    `${window.flatfile.configService.get('VITE_BASE_API_URL')}/v1/users/${userId}`
  )

  return response
}
